import * as ko from "knockout";

export class UserSearchCriteria {
  generalSearch: KnockoutObservable<string>;
  product_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  count: KnockoutObservable<number>;
  page_dir: KnockoutObservable<string>;
  sort_dir: KnockoutObservable<string>;
  created_dttm_last_value: KnockoutObservable<Date>;
  sort_field_last_value: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  place_id: KnockoutObservable<string>;
  status: KnockoutObservable<string>;

  constructor(item) {
    this.generalSearch = ko.observable(item.generalSearch);
    this.product_id = ko.observable(item.product_id);
    this.model_id = ko.observable(item.model_id);
    this.part_id = ko.observable(item.part_id);
    this.serial_id = ko.observable(item.serial_id);
    this.Page = ko.observable(item.Page || 0);
    this.Rows = ko.observable(item.Rows || 15);
    this.count = ko.observable(0);
    this.page_dir = ko.observable(item.page_dir);
    this.sort_dir = ko.observable(item.sort_dir);
    this.sort_field = ko.observable(item.sort_field);
    this.sort_field_last_value = ko.observable(item.sort_field_last_value);
    this.created_dttm_last_value = ko.observable(item.created_dttm_last_value);
    this.place_id = ko.observable(item.place_id);
    this.status = ko.observable(item.status);
  }
}
